export default __webpack_public_path__ + "images/f2cc994717b56016be81997b786bd498.svg";